import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "countdown", "status"]
  static values = {
    availableAt: String,
    waitTemplate: String,
    readyText: String,
    statusReadyText: String,
    secondOne: String,
    secondOther: String
  }

  connect() {
    this.wasWaiting = this.remainingSeconds() > 0
    this.refresh()

    if (this.wasWaiting) {
      this.timer = window.setInterval(() => this.refresh(), 1000)
    }
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  refresh() {
    const remaining = this.remainingSeconds()

    if (remaining > 0) {
      this.buttonTarget.disabled = true
      this.countdownTarget.textContent = this.waitTemplateValue.replace(
        "__duration__",
        this.formatDuration(remaining)
      )
      return
    }

    this.buttonTarget.disabled = false
    this.countdownTarget.textContent = this.readyTextValue

    if (this.wasWaiting) {
      this.statusTarget.textContent = this.statusReadyTextValue
      this.wasWaiting = false
    }

    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }

  remainingSeconds() {
    const availableAt = new Date(this.availableAtValue).getTime()

    return Math.max(0, Math.ceil((availableAt - Date.now()) / 1000))
  }

  formatDuration(seconds) {
    if (seconds < 60) {
      const unit = seconds === 1 ? this.secondOneValue : this.secondOtherValue
      return `${seconds} ${unit}`
    }

    const minutes = Math.floor(seconds / 60)
    const remainder = String(seconds % 60).padStart(2, "0")

    return `${minutes}:${remainder}`
  }
}
